import React from 'react';
import { WarningIcon } from '@chakra-ui/icons';
import { Box, Flex, Text, Heading } from '@chakra-ui/react';

const Notfound: React.FC = () => {
    return (
        <Flex
            id="not_found_404"
            justify="center"
            align="center"
            height="100vh"
            overflow="hidden"
            direction="row"
            bg="white"
        >
            <Box
                width="600px"
                backgroundColor="#ebebeb"
                padding="20px"
                borderRadius="8px"
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                boxShadow="sm"
            >
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    width="80px"
                    height="80px"
                    bg="gray.200"
                    borderRadius="50%"
                    marginRight="10px"
                >
                    <WarningIcon color="red.500" boxSize={6} />
                </Box>
                <Box flex="1">
                    <Heading as="h3" size="md" fontWeight="bold" color="gray.700" marginBottom="5px">
                        TOPICS NOT FOUND
                    </Heading>
                    <Text color="gray.600" lineHeight="1.5">
                        記事が見つかりません
                    </Text>
                </Box>
            </Box>
        </Flex>
    );
};

export default Notfound;
